import React from 'react'
import WhiteButton from '../Buttons/WhiteButton'
import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'
import { useRouter } from 'next/router'

const defaultHeading = 'Mailer Samples for Roofing Companies'
const defaultSubheading =
    'See the proven designs roofers are using to generate calls and inspections'

const defaultSamples = [
    '/assets/roofers/mailer-samples/Roofers-AgingRoof_page.jpg',
    '/assets/roofers/mailer-samples/Roofers-Neighborho_page.jpg',
    '/assets/roofers/mailer-samples/Roofers-StormDama_page.jpg',
    '/assets/roofers/mailer-samples/Roofing-MissingSh.jpg',
    '/assets/roofers/mailer-samples/Roofing-MissingSh2.jpg',
    '/assets/roofers/mailer-samples/Roofing-OneLeakC.jpg',
    '/assets/roofers/mailer-samples/Roofing-StormDama_page.jpg',
    '/assets/roofers/mailer-samples/Roofing-StormDama.jpg',
].map((src, i) => ({ src, alt: `Mailer sample ${i + 1}` }))

const defaultCTA = {
    label: 'Get Free Industry Samples Now',
    href: '/get-free-samples',
}

function SampleThumb({ src, alt }) {
    return (
        <div className="w-11/12 md:w-full">
            <div className="aspect-video overflow-hidden shadow-md">
                <img
                    src={src}
                    alt={alt || 'Mailer sample'}
                    className="h-full w-full object-cover"
                />
            </div>
        </div>
    )
}

export default function MailerSamples(props) {
    const heading = props?.heading || defaultHeading
    const subheading = props?.subheading || defaultSubheading
    const samples =
        Array.isArray(props?.samples) && props.samples.length > 0
            ? props.samples
            : defaultSamples
    const cta = props?.cta || defaultCTA
    const router = useRouter()

    return (
        <section
            className="relative overflow-hidden rounded-tr-[43px] rounded-bl-[43px] lg:rounded-tr-[160px] lg:rounded-bl-[160px]"
            style={{
                background:
                    'linear-gradient(103.29deg, #F15A22 4.82%, #FAB132 98.82%)',
            }}>
            <div className="relative z-10 container mx-auto px-4 py-6 lg:py-12">
                {/* Content wrapper (full-width gradient applied to section now) */}
                <div className="">
                    {/* Heading & subheading */}
                    <SectionHeading color={'text-white'}>
                        {heading}
                    </SectionHeading>
                    <SectionSubText color={'text-white'}>
                        {subheading}
                    </SectionSubText>

                    {/* Samples grid */}
                    <div className="mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6 justify-items-center">
                        {samples.slice(0).map((s, i) => (
                            <SampleThumb key={i} src={s.src} alt={s.alt} />
                        ))}
                    </div>

                    {/* CTA */}
                    {cta?.label ? (
                        <div className="mt-10 sm:mt-12 flex justify-center max-w-sm mx-auto">
                            <WhiteButton
                                onClick={() => {
                                    router.push(cta?.href)
                                }}>
                                {cta.label}
                            </WhiteButton>
                        </div>
                    ) : null}
                </div>
            </div>
        </section>
    )
}
